/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PostAlliancesGwsApplicationsRequestBillingAdminOrganization } from './post-alliances-gws-applications-request-billing-admin-organization';
// May contain unused imports in some cases
// @ts-ignore
import { PostAlliancesGwsApplicationsRequestBillingAdminPerson } from './post-alliances-gws-applications-request-billing-admin-person';

/**
 * 
 * @export
 * @interface PostAlliancesGwsApplicationsRequest
 */
export interface PostAlliancesGwsApplicationsRequest {
    /**
     * 
     * @type {PostAlliancesGwsApplicationsRequestBillingAdminOrganization}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'billingAdminOrganization': PostAlliancesGwsApplicationsRequestBillingAdminOrganization;
    /**
     * 
     * @type {PostAlliancesGwsApplicationsRequestBillingAdminPerson}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'billingAdminPerson': PostAlliancesGwsApplicationsRequestBillingAdminPerson;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'billingUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contractType': PostAlliancesGwsApplicationsRequestContractTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'edition': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'numberOfIds': number;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'paymentPlan': PostAlliancesGwsApplicationsRequestPaymentPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contactPersonName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contactTel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contactEmail': string;
}

export const PostAlliancesGwsApplicationsRequestContractTypeEnum = {
    new: 'NEW',
    update: 'UPDATE'
} as const;

export type PostAlliancesGwsApplicationsRequestContractTypeEnum = typeof PostAlliancesGwsApplicationsRequestContractTypeEnum[keyof typeof PostAlliancesGwsApplicationsRequestContractTypeEnum];
export const PostAlliancesGwsApplicationsRequestPaymentPlanEnum = {
    monthly: 'MONTHLY',
    annual: 'ANNUAL'
} as const;

export type PostAlliancesGwsApplicationsRequestPaymentPlanEnum = typeof PostAlliancesGwsApplicationsRequestPaymentPlanEnum[keyof typeof PostAlliancesGwsApplicationsRequestPaymentPlanEnum];


